
import {
    addSection,
    deleteSection,
    updateSection,
    getSections,
    getSection,
    searchSection,
    searchSectionForCurrentUser
} from '@/services/endpoints/section'

export default {
    async addSection({ commit }, payload) {
        try {
            let res = await addSection(payload)
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },

    async deleteSection({ commit }, payload) {
        try {
            let res = await deleteSection(payload.sectionsId)
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },
    async getSections({ commit },payload) {
        try {
            let res = await getSections(payload);
            if(res) {
                res.data.data.forEach((s,index) => {
                    s.id = index
                });
                commit('SET_SECTIONS', res.data.data)
                commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async updateSection({commit},payload) {
        try {
            let res = await updateSection(payload.id, payload.payload);
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },
    async searchSection({ commit }, payload) {
        try {
            let res = await searchSection(payload);
            if(res) {
                res.data.data.forEach((s,index) => {
                    s.id = index
                });

                commit('SET_SECTIONS', res.data.data)
                commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async searchSectionForCurrentUser({ commit }, payload) {
        try {
            let res = await searchSectionForCurrentUser(payload);
            if(res) {
                res.data.data.forEach((s,index) => {
                    s.id = index
                });

                commit('SET_SECTIONS_FOR_CURRENT_USER', res.data.data)
                commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async getSectionToEdit({ commit }, sectionId) {
        try {
            let res = await getSection(sectionId);
            if(res) {
                commit('SET_SECTION_TO_EDIT', res.data)
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
}